import { Link } from 'react-router-dom';
import { ArrowLeft, Award, Star, Zap, CheckCircle } from 'lucide-react';

export default function SponsorshipPage() {
  return (
    <div style={{ background: 'var(--surface-body)', minHeight: '100vh', color: 'var(--text-primary)' }}>
      {/* Nav */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, height: 72, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 40px', background: 'rgba(10,12,20,0.85)', backdropFilter: 'blur(20px)', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <div style={{ fontFamily: 'var(--font-display)', fontSize: '1.1rem', color: 'var(--gold)' }}>Futurum Innovation Awards</div>
        <Link to="/season2" style={{ fontSize: '0.875rem', color: 'var(--teal)' }}>Season II ↗</Link>
      </nav>

      <div style={{ paddingTop: 72 }}>
      {/* Corporate Sponsorship Tiers */}
      <section id="sponsor" style={{ padding: '100px 0', background: 'rgba(201,162,39,0.03)', borderTop: '1px solid rgba(255,255,255,0.05)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 64 }}>
            <div className="eyebrow" style={{ marginBottom: 12 }}>Corporate Partnerships</div>
            <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 400, marginBottom: 16 }}>
              Invest in <span style={{ color: 'var(--gold)', fontStyle: 'italic' }}>Nigeria's Future</span>
            </h2>
            <p style={{ color: 'var(--text-secondary)', maxWidth: 560, margin: '0 auto', lineHeight: 1.7 }}>
              Partner with Futurum Innovation Awards and connect your organisation with the brightest engineering minds at OAU. Choose a sponsorship tier that fits your goals.
            </p>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24, alignItems: 'start' }}>
            {/* Silver */}
            <div className="tier-card tier-silver">
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                <Star size={20} style={{ color: '#c0c0c0' }} />
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.7rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#c0c0c0' }}>Silver Tier</div>
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 600, color: '#c0c0c0', marginBottom: 4 }}>₦1,500,000</div>
              <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: 24 }}>per season</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 28 }}>
                {['Logo on event materials & website', 'Brand mention at awards ceremony', 'Access to student talent pool', '1 sponsored research topic', 'Post-event impact report'].map(b => (
                  <div key={b} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                    <CheckCircle size={15} style={{ color: '#c0c0c0', flexShrink: 0, marginTop: 2 }} /> {b}
                  </div>
                ))}
              </div>
              <a href="mailto:admin@futurumawards.com?subject=Silver Sponsorship Enquiry" className="btn btn-secondary" style={{ width: '100%', justifyContent: 'center', borderColor: 'rgba(192,192,192,0.4)', color: '#c0c0c0' }}>Get Started</a>
            </div>

            {/* Gold — Featured */}
            <div className="tier-card tier-gold" style={{ transform: 'scale(1.03)', boxShadow: '0 8px 40px rgba(201,162,39,0.15)' }}>
              <div style={{ position: 'absolute', top: 16, right: 16, background: 'var(--gold)', color: '#0a0c14', fontSize: '0.65rem', fontWeight: 700, padding: '3px 10px', borderRadius: 999, letterSpacing: '0.08em', textTransform: 'uppercase', fontFamily: 'var(--font-mono)' }}>Most Popular</div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                <Award size={20} style={{ color: 'var(--gold)' }} />
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.7rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: 'var(--gold)' }}>Gold Tier</div>
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 600, color: 'var(--gold)', marginBottom: 4 }}>₦5,000,000</div>
              <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: 24 }}>per season</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 28 }}>
                {['Everything in Silver', 'Prominent logo placement — all materials', 'Dedicated brand segment at ceremony', '3 sponsored research topics', 'Judge panel representation', 'Recruitment pipeline access', 'Quarterly progress briefings'].map(b => (
                  <div key={b} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                    <CheckCircle size={15} style={{ color: 'var(--gold)', flexShrink: 0, marginTop: 2 }} /> {b}
                  </div>
                ))}
              </div>
              <a href="mailto:admin@futurumawards.com?subject=Gold Sponsorship Enquiry" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center' }}>Get Started</a>
            </div>

            {/* Platinum */}
            <div className="tier-card tier-platinum">
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                <Zap size={20} style={{ color: '#e5e4e2' }} />
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.7rem', letterSpacing: '0.2em', textTransform: 'uppercase', color: '#e5e4e2' }}>Platinum Tier</div>
              </div>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: '2rem', fontWeight: 600, color: '#e5e4e2', marginBottom: 4 }}>₦7,500,000+</div>
              <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginBottom: 24 }}>per season · custom packages available</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 28 }}>
                {['Everything in Gold', 'Title sponsorship — event named after brand', 'Keynote speaking slot at ceremony', 'Unlimited sponsored research topics', 'Co-designed research agenda', 'Exclusive access to all project IP', 'Year-round brand activation', 'Custom talent acquisition programme'].map(b => (
                  <div key={b} style={{ display: 'flex', alignItems: 'flex-start', gap: 10, fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                    <CheckCircle size={15} style={{ color: '#e5e4e2', flexShrink: 0, marginTop: 2 }} /> {b}
                  </div>
                ))}
              </div>
              <a href="mailto:admin@futurumawards.com?subject=Platinum Sponsorship Enquiry" className="btn btn-secondary" style={{ width: '100%', justifyContent: 'center', borderColor: 'rgba(229,228,226,0.4)', color: '#e5e4e2' }}>Contact Us</a>
            </div>
          </div>

          <p style={{ textAlign: 'center', marginTop: 32, fontSize: '0.8rem', color: 'var(--text-muted)' }}>
            All enquiries: <a href="mailto:admin@futurumawards.com" style={{ color: 'var(--teal)' }}>admin@futurumawards.com</a>
          </p>
        </div>
      </section>


      </div>

      {/* Footer */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', padding: '48px 40px 24px', textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem', marginTop: 80 }}>
        Futurum Innovation Awards · A Futurum Innovation Ltd initiative
      </div>
    </div>
  );
}
